import { FileBucket } from "@/models/file-bucket.model"
import { RentalMutation } from "@/models/rental-mutation.model"
import { Transaction } from "@/models/transaction.model"
import { PurchaseItem } from "@/models/purchase-item.model"
import { SaleItem } from "@/models/sale-item.model"
import { RentalIntakeItem } from "@/models/rental-intake-item.model"
import { RentalDispenseItem } from "@/models/rental-dispense-item.model"
import { ProjectPurchaseItem } from "@/models/project-purchase-item.model"
import { ProjectSaleItem } from "@/models/project-sale-item.model"
import { ProjectRentalIntakeItem } from "@/models/project-rental-intake-item.model"
import { ProjectRentalDispenseItem } from "@/models/project-rental-dispense-item.model"
import { KnownBusinessEntitySaleItem } from "@/models/known-business-entity-sale-item.model.ts"
import { KnownBusinessEntityRentalDispenseItem } from "@/models/known-business-entity-rental-dispense-item.model.ts"
import type { IPurchaseItem } from "@/interfaces/api/purchase-item.interface"
import type { ISaleItem } from "@/interfaces/api/sale-item.interface"
import type { IRentalIntakeItem } from "@/interfaces/api/rental-intake-item.interface"
import type { IRentalDispenseItem } from "@/interfaces/api/rental-dispense-item.interface"

export type AdministrativeEvent = Transaction | RentalMutation

export type TransactionItem = PurchaseItem | SaleItem

export type RentalItem = RentalIntakeItem | RentalDispenseItem

export type AdministrativeItem = TransactionItem | RentalItem

export type IAdministrativeItem =
  IPurchaseItem | ISaleItem | IRentalIntakeItem | IRentalDispenseItem

export type PartialAdministrativeEvent = {
  quantity?: string
  fileBucket?: FileBucket
  [key: string]: any
}

export type ProjectTransactionItem = ProjectPurchaseItem | ProjectSaleItem

export type ProjectRentalItem = ProjectRentalIntakeItem | ProjectRentalDispenseItem

export type ProjectAdministrativeItem = ProjectTransactionItem | ProjectRentalItem

export type KnownBusinessEntityAdministrativeItem =
  KnownBusinessEntitySaleItem | KnownBusinessEntityRentalDispenseItem

export type AdministrativeItemPriceAgreement =
  ProjectAdministrativeItem | KnownBusinessEntityAdministrativeItem

export function isAdministrativeEvent(event: unknown) {
  return event instanceof Transaction || event instanceof RentalMutation
}

export function isTransactionItem(item: unknown) {
  return item instanceof PurchaseItem || item instanceof SaleItem
}

export function isRentalItem(item: unknown) {
  return item instanceof RentalIntakeItem || item instanceof RentalDispenseItem
}

export function isProjectTransactionItem(item: unknown): item is ProjectTransactionItem {
  return item instanceof ProjectPurchaseItem || item instanceof ProjectSaleItem
}

export function isKnownBusinessEntityTransactionItem(
  item: unknown
): item is KnownBusinessEntitySaleItem {
  return item instanceof KnownBusinessEntitySaleItem
}

export function isPriceAgreementTransactionItem(
  item: unknown
): item is ProjectTransactionItem | KnownBusinessEntitySaleItem {
  return isProjectTransactionItem(item) || isKnownBusinessEntityTransactionItem(item)
}
